import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'distance' } )
export class DistancePipe implements PipeTransform {

    transform( pDistance: number ): string {
        if (pDistance == 0) {
            return '0 Km';
        } else {
            return `${(pDistance / 1000).toFixed(2)} Km`;
        }
    }
}